<template>
    <img
        v-if="showImage"
        :src="avatar"
        :class="['pl-avatar', sizeClass]"
        :alt="alt"
        loading="lazy"
        decoding="async"
        @error="failed = true"
    />
    <div
        v-else
        :class="['pl-avatar', sizeClass, 'pl-avatar--monogram']"
        aria-hidden="true"
        :style="{ '--pl-avatar-tint': tint }"
    >{{ monogram }}</div>
</template>

<script setup>
import {computed, ref, watch} from 'vue';
import {avatarTintVar, hasAnyAvatar, monogramOf} from './characterPresentation.js';

const props = defineProps({
    characterId: {type: String, default: ''},
    name: {type: String, default: ''},
    avatar: {type: String, default: ''},
    size: {type: String, default: 'md'},
    distinguishing: {type: Boolean, default: true},
    alt: {type: String, default: ''},
});

const failed = ref(false);

watch(() => props.avatar, () => {
    failed.value = false;
});

const sizeClass = computed(() => `pl-avatar--${props.size}`);
/*
 * The male/female/other placeholders are real artwork and are shown as-is. The
 * monogram is only the last resort for a character with no avatar path at all,
 * or one whose image fails to load.
 */
const showImage = computed(() => hasAnyAvatar(props.avatar) && !failed.value);
const monogram = computed(() => monogramOf(props.name));
const tint = computed(() => avatarTintVar(props.characterId));
</script>
